import Image from "next/image";
import { withCDN } from "@/src/lib/utils";

export default function WhyYoungEngineersSkeleton() {
  return (
    <section className="relative w-full overflow-hidden py-24 z-20 mt-[-128px]">
      {/* Content wrapper - Heights match exactly with Client.tsx */}
      <div
        className="
          relative my-13 mx-auto w-full
          min-h-[260px] md:min-h-[520px] lg:min-h-[720px] xl:min-h-[650px]
          gap-2.5 px-4 md:px-10 lg:px-18 xl:px-34
        "
      >
        {/* Title Shimmer */}
        <div className="h-8 md:h-10 w-48 md:w-64 bg-gray-200 rounded animate-pulse mb-2.5 2xl:mb-7.5 mt-[-20px]"></div>

        {/* Features Navigation Shimmer */}
        <div className="flex flex-nowrap items-center gap-4 md:gap-1 lg:gap-2 xl:gap-2 mb-6 2xl:mb-7.5 overflow-hidden">
          <div className="h-4 w-24 md:w-32 bg-gray-200 rounded animate-pulse flex-shrink-0"></div>
          <div className="h-4 w-28 md:w-40 bg-gray-200 rounded animate-pulse flex-shrink-0"></div>
          <div className="h-4 w-32 md:w-36 bg-gray-200 rounded animate-pulse flex-shrink-0"></div>
          <div className="h-4 w-24 md:w-32 bg-gray-200 rounded animate-pulse flex-shrink-0 hidden md:block"></div>
        </div>

        {/* Layout Shimmer (Matches the Carousel Item layout) */}
        <div
          className="
            grid grid-cols-1 md:grid-cols-[auto_1fr]
            items-center gap-6 xl:gap-10 mt-4 md:mt-8
            justify-items-center md:justify-items-start
          "
        >
          {/* LEFT — Image Shimmer */}
          <div
            className="
              relative bg-gray-200 rounded-xl animate-pulse flex-shrink-0
              w-[288px] md:w-[320px] lg:w-[340px] xl:w-[525px]
              h-[166px] md:h-[300px] lg:h-[400px]
            "
          ></div>

          {/* RIGHT — Text Shimmer */}
          <div className="space-y-4 md:space-y-6 w-full max-w-2xl xl:mt-[-60px] px-2 md:px-0">
            {/* Subtitle */}
            <div className="h-6 md:h-8 w-3/4 bg-gray-200 rounded animate-pulse"></div>

            {/* Paragraph lines */}
            <div className="space-y-3">
              <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-4/5 bg-gray-200 rounded animate-pulse"></div>
            </div>

            {/* Button Shimmer */}
            <div
              className="
                mt-6 bg-gray-200 rounded-full animate-pulse
                min-w-[264px] h-[43px] 2xl:min-w-[355px] 2xl:h-[60px] lg:min-w-[355px] lg:h-[60px] xl:min-w-[355px] xl:h-[60px] max-[480px]:w-full max-[480px]:mt-[20px]
              "
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}
